import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "@tanstack/react-router";

import { createParticipantLoaderOptions } from "@/loaders/participant";
import { Lobby } from "@/pages/participant/lobby";

export const Route = createFileRoute("/participate/$session_token/lobby")({
  component: Lobby,
  loader: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData(createParticipantLoaderOptions());
    if (!user.name) {
      throw redirect({ to: "/participate/setup" });
    }
    return user;
  },
});
